/**
 * Global store-reset action.
 *
 * Kept in its own module (no imports) so both the root reducer (`store/index.ts`)
 * and the code that dispatches it (`authSlice` logout) can reference it without a
 * circular import. Dispatching `{ type: RESET_STORE }` returns every slice to its
 * initial state — used at logout so no tenant/user data survives into the next
 * login on the same tab.
 */
export const RESET_STORE = 'app/RESET_STORE' as const;

export const resetStore = () => ({ type: RESET_STORE });
